var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 56,
    viewBox: "0 0 151 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6291 52.3811H55.2548V25.3325H59.8407V48.2026H72.6291V52.3811Z",
    fill: "#00142C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3256 40.7037H93.5081V36.4878H88.2884H81.8009H77.1777V40.7037H81.8009H88.3256Z",
    fill: "#0EC9AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1777 25.3325V29.5111H81.8009H88.2884H96.1926V25.3325H77.1777Z",
    fill: "#0EC9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8009 48.2399H77.1777V52.3811H96.1926V48.2399H88.3256H81.8009Z",
    fill: "#0EC9AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.584 25.3325H115.207L125.721 52.3811H120.912L118.638 46.6356H107.117L104.88 52.3811H100.033L110.584 25.3325ZM116.997 42.4198L112.859 31.6003L108.757 42.4198H116.997Z",
    fill: "#00142C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.26 52.3812H129.674V25.3325H134.26V37.9055L144.363 25.3325H150.068L140.933 36.7862L150.963 52.4185H145.445L137.764 40.6663L134.26 44.9568V52.3812Z",
    fill: "#00142C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.962 16.6023L68.4906 18.2812C67.0365 20.1093 65.1351 21.0047 62.7489 21.0047C60.5491 21.0047 58.7595 20.3331 57.3427 18.9527C55.9259 17.5723 55.2175 15.7815 55.2175 13.5803C55.2175 11.3791 55.9259 9.58829 57.3054 8.17057C58.7222 6.79016 60.5119 6.0813 62.6743 6.0813C65.0978 6.0813 66.962 6.9767 68.3042 8.80482L66.701 10.4464C65.6943 9.02867 64.3894 8.31981 62.7116 8.31981C61.2948 8.31981 60.1017 8.80482 59.1323 9.81214C58.2002 10.8195 57.7156 12.0506 57.7156 13.543C57.7156 15.0353 58.2002 16.2665 59.1696 17.2365C60.139 18.2065 61.3694 18.6916 62.7862 18.6916C64.4639 18.7662 65.8435 18.02 66.962 16.6023Z",
    fill: "#00142C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9952 6.34241H74.6051L78.0725 13.0579L81.5026 6.34241H84.1498L79.3029 15.7441V20.7808H76.8049V15.7441L71.9952 6.34241Z",
    fill: "#00142C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5894 15.8561H91.5321V20.7808H89.1086V6.34241H94.5894C96.3044 6.34241 97.6467 6.7528 98.616 7.57359C99.5854 8.39437 100.07 9.55094 100.07 11.0433C100.07 12.5356 99.5854 13.6922 98.5788 14.5503C97.6467 15.4084 96.3044 15.8561 94.5894 15.8561ZM94.2911 8.54361H91.5694V13.5802H94.2911C96.5281 13.5802 97.6467 12.7222 97.6467 11.0433C97.6467 9.4017 96.5281 8.54361 94.2911 8.54361Z",
    fill: "#00142C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 20.7808H114.462V14.5503H107.676V20.7808H105.215V6.34241H107.676V12.3118H114.462V6.34241H116.922V20.7808Z",
    fill: "#00142C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151 20.7808H148.092L145.072 15.8561H142.089V20.7808H139.628V6.34241H145.109C146.824 6.34241 148.166 6.7528 149.136 7.57359C150.105 8.39437 150.59 9.55094 150.59 11.0433C150.59 12.0879 150.329 13.0206 149.844 13.7668C149.322 14.513 148.614 15.0726 147.644 15.4457L151 20.7808ZM144.811 8.54361H142.089V13.5802H144.811C147.048 13.5802 148.166 12.7222 148.166 11.0433C148.166 9.4017 147.048 8.54361 144.811 8.54361Z",
    fill: "#00142C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.298 12.2744V14.5502H125.759H132.097V12.2744H125.759H123.298Z",
    fill: "#00142C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.759 8.54361H133.439V6.34241H123.298V8.54361H125.759Z",
    fill: "#00142C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.298 18.5422V20.7807H133.439V18.5422H125.759H123.298Z",
    fill: "#00142C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.28247V35.2192L26.8817 8.28247H0Z",
    fill: "#00142C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1788 0V10.0733L36.8365 11.4164L5.03333 43.2405L0 38.2039L38.1788 0Z",
    fill: "#0EC9AC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1788 12.7222V22.7955L36.8365 24.1386L11.3716 49.6202L6.33826 44.5463L38.1788 12.7222Z",
    fill: "#0EC9AC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 50.926L13.3477 51.5976L14.0188 52.2318L17.7472 56L38.1788 35.5922V25.4443L12.7139 50.926Z",
    fill: "#0EC9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightMode);
export default __webpack_public_path__ + "static/media/logo-light-mode.9c8f3080c4cdaf25bd1fa53bc45c0b5a.svg";
export { ForwardRef as ReactComponent };